module.exports = __webpack_public_path__ + "img/insta.da3e4fda.png";